module.exports = __webpack_public_path__ + "img/download-all.6f61aab7.svg";